import { render, staticRenderFns } from "./MandellsSearch.vue?vue&type=template&id=3b39df64&scoped=true"
import script from "./MandellsSearch.vue?vue&type=script&lang=js"
export * from "./MandellsSearch.vue?vue&type=script&lang=js"
import style0 from "./MandellsSearch.vue?vue&type=style&index=0&id=3b39df64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b39df64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
